import { useState } from "react"
import { Alert, Form, Input } from "antd"
import { Link } from "react-router-dom"
import { AxiosError } from "axios"
import AuthPageLayout, { PrimaryButton } from "../Login/AuthPageLayout"
import { postPasswordForgot } from "./apiCalls"

type TPasswordForgotForm = {
    email: string
}

const forgotErrorText = (error: unknown) => {
    const response = (error as AxiosError<{ displayMessage?: string }>)?.response
    if (response?.data?.displayMessage) return response.data.displayMessage
    if (response?.status === 429) return "Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut."
    return "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut."
}

/** `/passwort/vergessen`: das Backend antwortet immer 200 (keine Enumeration), die Seite zeigt immer dieselbe Bestätigung. */
export default function PasswordForgot() {
    const [submitting, setSubmitting] = useState(false)
    const [errorText, setErrorText] = useState<string | undefined>(undefined)
    const [done, setDone] = useState(false)

    const onFinish = async (values: TPasswordForgotForm) => {
        setSubmitting(true)
        setErrorText(undefined)
        try {
            await postPasswordForgot(values.email.trim())
            setDone(true)
        } catch (error) {
            setErrorText(forgotErrorText(error))
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <AuthPageLayout title="Passwort vergessen">
            {done ? (
                <Alert
                    type="success"
                    showIcon
                    message="Wenn die E-Mail-Adresse bekannt ist, haben wir Ihnen einen Link geschickt."
                    description="Der Link ist 60 Minuten gültig."
                />
            ) : (
                <>
                    <p className="text-sm text-gray-600">
                        Geben Sie Ihre E-Mail-Adresse ein. Wir schicken Ihnen einen Link, mit dem Sie ein neues Passwort setzen können.
                    </p>
                    {errorText && <Alert type="error" showIcon message={errorText} />}
                    <Form<TPasswordForgotForm> layout="vertical" requiredMark={false} onFinish={onFinish} disabled={submitting}>
                        <Form.Item
                            label="E-Mail"
                            name="email"
                            rules={[
                                { required: true, message: "Bitte E-Mail-Adresse eingeben" },
                                { type: "email", message: "Bitte eine gültige E-Mail-Adresse eingeben" },
                            ]}>
                            <Input autoComplete="username" autoFocus size="large" />
                        </Form.Item>
                        <PrimaryButton type="submit" disabled={submitting} loading={submitting}>
                            Link anfordern
                        </PrimaryButton>
                    </Form>
                </>
            )}
            <div className="text-center">
                <Link to="/login" className="text-primary hover:underline">
                    Zurück zur Anmeldung
                </Link>
            </div>
        </AuthPageLayout>
    )
}
